// extracted by mini-css-extract-plugin
export var arrow = "bc_9";
export var career = "bc_dN";
export var careerContainer = "bc_dM";
export var container = "bc_b";
export var link = "bc_bs";
export var location = "bc_cf";
export var section = "bc_d";
export var title = "bc_h";